import * as React from 'react';

const SectionRightSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fill="#010101"
            d="M13 17h6v2h-6v-2zm-1 3h8v-4h-8v4zM4 10v4h16v-4H4zm15 3H5v-2h14v2zM4 4v4h16V4H4zm15 3H5V5h14v2z"
        />
    </svg>
);

SectionRightSvg.displayName = 'SectionRightSvg';
export default SectionRightSvg;
